import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DateUtilService} from '@util/date-util.service';
import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';
import {PlatformService} from '@util/platform.service';
import {ScoopfreeActivity} from '@model/product/scoopfree/activity/scoopfree-activity.model';
import {ScoopfreeActivityType} from '@model/product/scoopfree/activity/scoopfree-activity-type.model';

@Component({
  selector: 'app-scoopfree-activity-feed',
  templateUrl: './scoopfree-activity-feed.component.html',
  styleUrls: ['./scoopfree-activity-feed.component.scss', '../../../user/customer/customer.component.scss'],
  animations: [
  trigger('slide', [
    transition('void => *', [
      style({ transform: 'translateX(-100%)', opacity: 0 }),
      animate('0.1s ease-in'),
    ]),
  ]),
  trigger('fade', [
    transition('void => *', [style({ opacity: 0 }), animate(200)]),
  ]),
  trigger('stagger', [
    transition('void => *', [
      query('div', stagger('-.005s ease-in', [animateChild()])),
    ]),
  ]),
]
})
export class ScoopfreeActivityFeedComponent implements OnInit, OnChanges {

  @Input()
  productActivities: Array<ScoopfreeActivity>;

  // @Input()
  activityTypes: Array<ScoopfreeActivityType>;

  /**
   * StartDate for Activity Feed Request Filter
   */
  @Input()
  startDate: Date = new Date();

  /**
   * EndDate for Activity Feed Request Filter
   */
  @Input()
  endDate: Date = new Date();

  activities: Array<{
    date: string;
    activities: Array<ScoopfreeActivity>;
    isCollapsed?: boolean;
  }>;

  /**
   * string value used to filter activities. Value must be either 'D', 'W' or 'M'
   */
  selectedChartFilter = 'D';


  /**
   * Tracks the state of the Activity Feed - Either Collapsed or Expanded
   */
  collapseAll = false;

  /**
   * enum used to filter activities on display and chart
   */
  selectedActivityType: ScoopfreeActivityType;

  constructor(private platformService: PlatformService) {
  }

  ngOnInit() {
    this.activityTypes = this.platformService.getById('scoopfree2').activityTypes;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedActivityType =
      ScoopfreeActivityType.SHOW_ALL;
    this.selectActivityType();
  }

  /**
   * Expands or Collapses All Activiities in Activity Feed when toggled
   */
  expandAll(): void {
    this.collapseAll = !this.collapseAll;
    if (this.activities) {
      for (const a of this.activities) {
        a.isCollapsed = this.collapseAll;
      }
    }
  }

  /**
   * selectActivityType
   *
   */
  selectActivityType(): void {
    this.collapseAll = false;
    this.activities = this.groupActivityByDate();
  }


  /**
   * groupActivityByDate
   *
   * @returns a json object array of groups of activities that are grouped by either matching date, week or month
   */
  groupActivityByDate(): Array<{
    date: string;
    activities: Array<ScoopfreeActivity>;
  }> {
    if (this.productActivities) {
      const groups = this.productActivities
        .filter((a: ScoopfreeActivity) => {
          if (
            this.selectedActivityType === ScoopfreeActivityType.SHOW_ALL
          ) {
            return true;
          } else {
            return ScoopfreeActivityType[
              a.code as unknown as keyof typeof ScoopfreeActivityType
              ] === this.selectedActivityType;
          }
        })
        .reduce((g: {}, activity: ScoopfreeActivity) => {
          const date = new Date(activity.timestamp).toISOString().split('T')[0];
          switch (this.selectedChartFilter) {
            case 'D':
              if (!g[date]) {
                g[date] = [];
              }
              g[date].push(activity);
              break;
            case 'W':
              const weekNo = DateUtilService.getWeekNumber(
                new Date(date),
              );
              if (!g[weekNo]) {
                g[weekNo] = [];
              }
              g[weekNo].push(activity);
              break;
            case 'M':
              const month = DateUtilService.getMonth(
                new Date(date),
              );
              if (!g[month]) {
                g[month] = [];
              }
              g[month].push(activity);
              break;
          }
          return g;
        }, {});
      const groupArray: Array<{
        date: string;
        activities: any;
      }> = Object.keys(groups).map((date: string) => {
        return {
          date,
          activities: groups[date],
        };
      });
      return groupArray.sort(
        (
          a: { date: string; activities: any },
          b: { date: string; activities: any },
        ) => {
          switch (this.selectedChartFilter) {
            case 'D':
              return (
                new Date(a.date).getTime() -
                new Date(b.date).getTime()
              );
            case 'W':
              return (
                new Date(a.activities[0].timestamp).getTime() -
                new Date(b.activities[0].timestamp).getTime()
              );
            case 'M':
              return (
                new Date(a.activities[0].timestamp).getTime() -
                new Date(b.activities[0].timestamp).getTime()
              );
          }
        },
      );
    }
    return null;
  }
}

// TODO - Confirm that order of sorted Events is correct
